import { formatDateOnly } from '@/utils/common'

const date = (data: any) => formatDateOnly(data)

export default date
